import rules from './rules';
import gateways from './gateways';
import cdr from './cdr';

export default {
    namespaced: true,
    modules: {
        rules,
        gateways,
        cdr,
    }
}